import { OrganizationType, SecurityLevel } from '../../../../utils/genericTypes'

const levelsByOrganizationType: Record<OrganizationType, SecurityLevel[]> = {
  [OrganizationType.Project]: [SecurityLevel.ProjectAdmin, SecurityLevel.ProjectUser],
  [OrganizationType.RCN]: [SecurityLevel.RCNAdmin, SecurityLevel.RCNUser],
  [OrganizationType.ISD]: [SecurityLevel.ISDAdmin, SecurityLevel.ISDUser],
  [OrganizationType.District]: [SecurityLevel.DistrictAdmin, SecurityLevel.DistrictUser]
}

export const securityLevelsFor = (organizationType?: OrganizationType): SecurityLevel[] =>
  organizationType == null ? [] : levelsByOrganizationType[organizationType] ?? []

/** A membership an administrator is creating starts at the least-privileged level for its organization. */
export const defaultSecurityLevelFor = (organizationType: OrganizationType): SecurityLevel | undefined => {
  const levels = securityLevelsFor(organizationType)
  return levels[levels.length - 1]
}
